var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 130,
    viewBox: "0 0 206 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.5 160.5H0.5V6C0.5 2.96243 2.96244 0.5 6 0.5H200C203.038 0.5 205.5 2.96244 205.5 6V160.5Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 40C44.8954 40 44 40.8954 44 42V53C44 54.1046 44.8954 55 46 55H59.9493C61.0539 55 61.9493 54.1046 61.9493 53V42C61.9493 40.8954 61.0539 40 59.9493 40H46Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 40C65.8954 40 65 40.8954 65 42V53C65 54.1046 65.8954 55 67 55H80.9493C82.0539 55 82.9493 54.1046 82.9493 53V42C82.9493 40.8954 82.0539 40 80.9493 40H67Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 40C86.8954 40 86 40.8954 86 42V53C86 54.1046 86.8954 55 88 55H101.949C103.054 55 103.949 54.1046 103.949 53V42C103.949 40.8954 103.054 40 101.949 40H88Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109 40C107.895 40 107 40.8954 107 42V53C107 54.1046 107.895 55 109 55H122.949C124.054 55 124.949 54.1046 124.949 53V42C124.949 40.8954 124.054 40 122.949 40H109Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 40C128.895 40 128 40.8954 128 42V53C128 54.1046 128.895 55 130 55H143.949C145.054 55 145.949 54.1046 145.949 53V42C145.949 40.8954 145.054 40 143.949 40H130Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151 40C149.895 40 149 40.8954 149 42V53C149 54.1046 149.895 55 151 55H164.949C166.054 55 166.949 54.1046 166.949 53V42C166.949 40.8954 166.054 40 164.949 40H151Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172 40C170.895 40 170 40.8954 170 42V53C170 54.1046 170.895 55 172 55H185.949C187.054 55 187.949 54.1046 187.949 53V42C187.949 40.8954 187.054 40 185.949 40H172Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 57C33.5228 57 38 52.5228 38 47C38 41.4772 33.5228 37 28 37C22.4772 37 18 41.4772 18 47C18 52.5228 22.4772 57 28 57Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8005 50.1018C30.759 50.1018 30.7175 50.0603 30.676 50.0603V50.0603C30.0536 49.8113 29.1822 49.3134 29.1822 48.608C29.1822 47.5292 30.427 47.3632 30.593 45.164C30.7175 43.3798 29.7631 42.0935 27.9789 42.0935C26.1947 42.0935 25.2403 43.3798 25.3648 45.164C25.5308 47.4047 26.7756 47.5707 26.7756 48.608C26.7756 49.3134 25.9042 49.8113 25.2818 50.0603V50.0603C25.2403 50.0603 25.1988 50.1018 25.1573 50.1018C24.8254 50.2678 24.5764 50.6412 24.5764 51.0562C24.5764 51.6371 25.0328 52.0935 25.6138 52.0935H27.9789H30.3441C30.925 52.0935 31.3814 51.6371 31.3814 51.0562C31.4229 50.6412 31.1739 50.2678 30.8005 50.1018V50.1018Z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 66C44.8954 66 44 66.8954 44 68V79C44 80.1046 44.8954 81 46 81H59.9493C61.0539 81 61.9493 80.1046 61.9493 79V68C61.9493 66.8954 61.0539 66 59.9493 66H46Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 66C65.8954 66 65 66.8954 65 68V79C65 80.1046 65.8954 81 67 81H80.9493C82.0539 81 82.9493 80.1046 82.9493 79V68C82.9493 66.8954 82.0539 66 80.9493 66H67Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 66C86.8954 66 86 66.8954 86 68V79C86 80.1046 86.8954 81 88 81H101.949C103.054 81 103.949 80.1046 103.949 79V68C103.949 66.8954 103.054 66 101.949 66H88Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109 66C107.895 66 107 66.8954 107 68V79C107 80.1046 107.895 81 109 81H122.949C124.054 81 124.949 80.1046 124.949 79V68C124.949 66.8954 124.054 66 122.949 66H109Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 66C128.895 66 128 66.8954 128 68V79C128 80.1046 128.895 81 130 81H143.949C145.054 81 145.949 80.1046 145.949 79V68C145.949 66.8954 145.054 66 143.949 66H130Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151 66C149.895 66 149 66.8954 149 68V79C149 80.1046 149.895 81 151 81H164.949C166.054 81 166.949 80.1046 166.949 79V68C166.949 66.8954 166.054 66 164.949 66H151Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172 66C170.895 66 170 66.8954 170 68V79C170 80.1046 170.895 81 172 81H185.949C187.054 81 187.949 80.1046 187.949 79V68C187.949 66.8954 187.054 66 185.949 66H172Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 83C33.5228 83 38 78.5228 38 73C38 67.4772 33.5228 63 28 63C22.4772 63 18 67.4772 18 73C18 78.5228 22.4772 83 28 83Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8005 76.1018C30.759 76.1018 30.7175 76.0603 30.676 76.0603V76.0603C30.0536 75.8113 29.1822 75.3134 29.1822 74.608C29.1822 73.5292 30.427 73.3632 30.593 71.164C30.7175 69.3798 29.7631 68.0935 27.9789 68.0935C26.1947 68.0935 25.2403 69.3798 25.3648 71.164C25.5308 73.4047 26.7756 73.5707 26.7756 74.608C26.7756 75.3134 25.9042 75.8113 25.2818 76.0603V76.0603C25.2403 76.0603 25.1988 76.1018 25.1573 76.1018C24.8254 76.2678 24.5764 76.6412 24.5764 77.0562C24.5764 77.6371 25.0328 78.0935 25.6138 78.0935H27.9789H30.344C30.925 78.0935 31.3814 77.6371 31.3814 77.0562C31.4229 76.6412 31.1739 76.2678 30.8005 76.1018V76.1018Z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 92C44.8954 92 44 92.8954 44 94V105C44 106.105 44.8954 107 46 107H59.9493C61.0539 107 61.9493 106.105 61.9493 105V94C61.9493 92.8954 61.0539 92 59.9493 92H46Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 92C65.8954 92 65 92.8954 65 94V105C65 106.105 65.8954 107 67 107H80.9493C82.0539 107 82.9493 106.105 82.9493 105V94C82.9493 92.8954 82.0539 92 80.9493 92H67Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 92C86.8954 92 86 92.8954 86 94V105C86 106.105 86.8954 107 88 107H101.949C103.054 107 103.949 106.105 103.949 105V94C103.949 92.8954 103.054 92 101.949 92H88Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109 92C107.895 92 107 92.8954 107 94V105C107 106.105 107.895 107 109 107H122.949C124.054 107 124.949 106.105 124.949 105V94C124.949 92.8954 124.054 92 122.949 92H109Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 92C128.895 92 128 92.8954 128 94V105C128 106.105 128.895 107 130 107H143.949C145.054 107 145.949 106.105 145.949 105V94C145.949 92.8954 145.054 92 143.949 92H130Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151 92C149.895 92 149 92.8954 149 94V105C149 106.105 149.895 107 151 107H164.949C166.054 107 166.949 106.105 166.949 105V94C166.949 92.8954 166.054 92 164.949 92H151Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172 92C170.895 92 170 92.8954 170 94V105C170 106.105 170.895 107 172 107H185.949C187.054 107 187.949 106.105 187.949 105V94C187.949 92.8954 187.054 92 185.949 92H172Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 109C33.5228 109 38 104.523 38 99C38 93.4772 33.5228 89 28 89C22.4772 89 18 93.4772 18 99C18 104.523 22.4772 109 28 109Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8005 102.102C30.759 102.102 30.7175 102.06 30.676 102.06V102.06C30.0536 101.811 29.1822 101.313 29.1822 100.608C29.1822 99.5292 30.427 99.3632 30.593 97.164C30.7175 95.3798 29.7631 94.0935 27.9789 94.0935C26.1947 94.0935 25.2403 95.3798 25.3648 97.164C25.5308 99.4047 26.7756 99.5707 26.7756 100.608C26.7756 101.313 25.9042 101.811 25.2818 102.06V102.06C25.2403 102.06 25.1988 102.102 25.1573 102.102C24.8254 102.268 24.5764 102.641 24.5764 103.056C24.5764 103.637 25.0328 104.094 25.6138 104.094H27.9789H30.344C30.925 104.094 31.3814 103.637 31.3814 103.056C31.4229 102.641 31.1739 102.268 30.8005 102.102V102.102Z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 118C44.8954 118 44 118.895 44 120V131C44 132.105 44.8954 133 46 133H59.9493C61.0539 133 61.9493 132.105 61.9493 131V120C61.9493 118.895 61.0539 118 59.9493 118H46Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 118C65.8954 118 65 118.895 65 120V131C65 132.105 65.8954 133 67 133H80.9493C82.0539 133 82.9493 132.105 82.9493 131V120C82.9493 118.895 82.0539 118 80.9493 118H67Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 118C86.8954 118 86 118.895 86 120V131C86 132.105 86.8954 133 88 133H101.949C103.054 133 103.949 132.105 103.949 131V120C103.949 118.895 103.054 118 101.949 118H88Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109 118C107.895 118 107 118.895 107 120V131C107 132.105 107.895 133 109 133H122.949C124.054 133 124.949 132.105 124.949 131V120C124.949 118.895 124.054 118 122.949 118H109Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 118C128.895 118 128 118.895 128 120V131C128 132.105 128.895 133 130 133H143.949C145.054 133 145.949 132.105 145.949 131V120C145.949 118.895 145.054 118 143.949 118H130Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151 118C149.895 118 149 118.895 149 120V131C149 132.105 149.895 133 151 133H164.949C166.054 133 166.949 132.105 166.949 131V120C166.949 118.895 166.054 118 164.949 118H151Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172 118C170.895 118 170 118.895 170 120V131C170 132.105 170.895 133 172 133H185.949C187.054 133 187.949 132.105 187.949 131V120C187.949 118.895 187.054 118 185.949 118H172Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 135C33.5228 135 38 130.523 38 125C38 119.477 33.5228 115 28 115C22.4772 115 18 119.477 18 125C18 130.523 22.4772 135 28 135Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8005 128.102C30.759 128.102 30.7175 128.06 30.676 128.06V128.06C30.0536 127.811 29.1822 127.313 29.1822 126.608C29.1822 125.529 30.427 125.363 30.593 123.164C30.7175 121.38 29.7631 120.094 27.9789 120.094C26.1947 120.094 25.2403 121.38 25.3648 123.164C25.5308 125.405 26.7756 125.571 26.7756 126.608C26.7756 127.313 25.9042 127.811 25.2818 128.06V128.06C25.2403 128.06 25.1988 128.102 25.1573 128.102C24.8254 128.268 24.5764 128.641 24.5764 129.056C24.5764 129.637 25.0328 130.094 25.6138 130.094H27.9789H30.344C30.925 130.094 31.3814 129.637 31.3814 129.056C31.4229 128.641 31.1739 128.268 30.8005 128.102V128.102Z",
    fill: "#BBBDBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 130,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/Tasks.4ac7346033cd576e638aad3fbc541a0a.svg";
export { ForwardRef as ReactComponent };